/**
 * Single source of truth for the public "Book a demo" CTA that routes
 * prospective companies / recruiters to Lea's Calendly booking page.
 *
 * Recruiter signups are invite-only - the public UI never exposes
 * /recruiter-signup; every "Become a recruiter" / "Get started" button
 * instead points here. Change this URL to swap the booking flow
 * everywhere in one place.
 */
export const RECRUITER_DEMO_URL =
  'https://calendly.com/lea-anders-cevee/meeting';
